import React from "react";
import { useNavigate } from "react-router-dom";
import { XO_GOLD } from "./xoConvergenceBrand";

const primaryLinkButton: React.CSSProperties = {
  color: XO_GOLD,
  textDecoration: "none",
  fontWeight: 500,
  fontSize: "0.875rem",
  letterSpacing: "0.02em",
  borderBottom: "1px solid rgba(200, 164, 77, 0.35)",
  background: "none",
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
  padding: 0,
  cursor: "pointer",
};

/**
 * Client-side navigation to Reserve / Signals — works when a lazy subtree has failed.
 */
export function XOPublicRecoveryNavLinks() {
  const navigate = useNavigate();
  return (
    <span style={{ fontSize: "0.8125rem", color: "rgba(246, 240, 230, 0.5)" }}>
      Try refreshing, or return to{" "}
      <button
        type="button"
        style={primaryLinkButton}
        onClick={() => {
          void navigate("/reserve", { replace: false });
        }}
      >
        Reserve
      </button>
      {" · "}
      <button
        type="button"
        style={primaryLinkButton}
        onClick={() => {
          void navigate("/drops/signals", { replace: false });
        }}
      >
        Signals
      </button>
      .
    </span>
  );
}

/** Same destinations, “Return to …” wording for not-found surfaces. */
export function XOPublicRecoveryNavLinksReturn() {
  const navigate = useNavigate();
  return (
    <p style={{ margin: "28px 0 0", fontSize: "0.8125rem", color: "rgba(246, 240, 230, 0.5)" }}>
      Return to{" "}
      <button
        type="button"
        style={primaryLinkButton}
        onClick={() => {
          void navigate("/reserve", { replace: false });
        }}
      >
        Reserve
      </button>
      {" · "}
      <button
        type="button"
        style={primaryLinkButton}
        onClick={() => {
          void navigate("/drops/signals", { replace: false });
        }}
      >
        Signals
      </button>
      .
    </p>
  );
}
